import { Checkbox, Form, Input } from "antd";
import { useEffect, useState } from "react";
import { useGlobalState } from "../../components/global";

export default function UserRoleForm({ form, item }: any) {
    const { jsonRequest } = useGlobalState();
    const [roleData, setRoleData] = useState<any>();

    useEffect(() => {
        const fetchData = async () => {
            try {
                await getRoleData();
                await getDetail();
            } catch (error) {
                console.error('数据获取失败:', error);
            }
        };

        fetchData();
    }, []);

    const getRoleData = async () => {
        return jsonRequest.get("/back/sys-role/list", {})
            .then((resp: any) => resp.json())
            .then(({ data }: any) => {
                setRoleData(data);
            });
    };

    const getDetail = async () => {
        jsonRequest.get(`/back/sys-user/${item.id}`, {})
            .then((resp: any) => resp.json())
            .then(async ({ data }: any) => {
                const roleIds = data.roles.map((role: any) => role.id);
                form.setFieldValue("roleIds", roleIds);
                form.setFieldValue("userName", item.userName);
            });
    };

    return (
        <Form form={form} size="small" name="basic" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} autoComplete="off">
            <Form.Item label="用户名称" name="userName" rules={[{ required: true, message: '不能为空' }]}>
                <Input disabled />
            </Form.Item>
            <Form.Item label="角色" name="roleIds">
                <Checkbox.Group
                    options={roleData?.map((e: any) => ({ value: e.id, label: e.roleName }))}
                />
            </Form.Item>
        </Form>
    )
}